<template>
  <Modal :id="'cmp-booking-plugins-activate'" @cancelled="onCancel">
    <template slot="header">Confirm Plugin Activation </template>
    <template slot="body">
      Activating this plugin <b>{{ pluginItem.name }}</b> will add EUR <b>{{ $dft.curr(pluginItem.price) }}</b> to your monthly bill. There may also be usage costs associated with the usage of this plugin, which are explained in the plugin. Do you want to proceed?
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{ $t("cancel") }}</button>
      <button class="dt-button v1 s6" @click.stop="onOK">{{ $t("ok") }}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal,
  },
  props: ["pluginItem"],
  data: function () {
    return {};
  },
  mounted: async function () {},
  computed: {},
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },
    onOK: function () {
      this.$emit("done", true);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-plugins-activate {
}
</style>
